import autobind from 'autobind-decorator';
import store from '../../../store';
import http from '../../../services/HttpService';

interface ResultInterface {
  datetime: string;
  lat: number;
  lng: number;
  accuracy: Nullable<number>;
  speed: Nullable<number>;
}

class DriverLocation {
  @autobind
  async initiate() {
    await this.delayed(5, this.detectLocation);
    await this.delayed(1, this.sendLocationQueue);
  }

  private sendingStarted: boolean = false;
  private sendingQueue: Array<ResultInterface> = [];
  // private detectedIndex: number = 0;

  @autobind
  private async delayed(seconds: number, callback: () => void) {
    await callback();

    return setInterval(() => {
      callback();
    }, seconds * 1000);
  }

  @autobind
  private detectLocation() {
    const { isLogged, user } = store.getState().AuthReducer;
    if (!isLogged || !user || !user.role || user.role.key != 'key_driver') {
      return;
    }

    if (!window || !window.navigator || !window.navigator.geolocation) {
      return;
    }

    // console.log('>>> detecting location ...');
    const dataToSend: ResultInterface = {
      datetime: this.getDateTime(),
      lat: 0,
      lng: 0,
      accuracy: null,
      speed: null,
    };

    const onDetectSuccess = (position: GeolocationPosition) => {
      const { latitude, longitude, accuracy, speed } = position.coords;
      dataToSend.lat = latitude;
      dataToSend.lng = longitude;
      dataToSend.accuracy = accuracy;
      dataToSend.speed = speed;

      // console.log('>>> location detected, registering in queue ...');
      this.sendingQueue.push(dataToSend);
    };

    const onDetectFail = (positionError: GeolocationPositionError) => {
      // console.log('>>> failed to detected location:', positionError);
    };

    window.navigator.geolocation.getCurrentPosition(onDetectSuccess, onDetectFail, {
      timeout: 2_000,
      enableHighAccuracy: true,
    });
  }

  @autobind
  private async sendLocationQueue() {
    if (this.sendingStarted) {
      return;
    }

    this.sendingStarted = true;
    while (this.sendingQueue.length > 0) {
      // // IN CASE OF QUEUE
      // const nonSendItem = this.sendingQueue.shift();

      // IN CASE OF LAST LOCATION
      const nonSendItem = this.sendingQueue.pop();
      this.sendingQueue = [];

      await this.sendLocation(nonSendItem);
    }

    this.sendingStarted = false;
  }

  @autobind
  private async sendLocation(dataToSend: ResultInterface) {
    // console.log('>>> sending driver location to server:', dataToSend);
    await http.post('/admin/driver-locations', dataToSend);
  }

  @autobind
  private getDateTime(): string {
    const merge = (values: Array<number>, glue: string): string =>
      values
        .map((value: number) => value.toString())
        .map((value: string) => {
          return value.length < 2 ? `0${value}` : value.toString();
        })
        .join(glue);

    const currentDateTimeInstance = new Date();

    const date = [
      currentDateTimeInstance.getFullYear(),
      currentDateTimeInstance.getMonth() + 1,
      currentDateTimeInstance.getDate(),
    ];

    const time = [
      currentDateTimeInstance.getHours(),
      currentDateTimeInstance.getMinutes(),
      currentDateTimeInstance.getSeconds(),
    ];

    return `${merge(date, '-')} ${merge(time, ':')}`;
  }
}

export default new DriverLocation();
